export const Paginator = {
  PageSizeOpts: [10, 20, 50],
};
